<template>
    <div class="stateInventory responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          title="Employee Listing"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'reports', label: 'Reports' },
            { name: 'employeeReport', label: 'Employee' },
            {
              name: 'employeeListActive',
              label: 'Employee Listing',
            },
          ]"
          @export="exportToCsv"
          :disableExport="!reportData"
        />
        <br class="no-print" />
        <ReportFilter
          class="no-print"
          @submit-filter="performGetReport"
          :isLoading="employeeTransactions"
          :filterByStoreOrOrg="false"
        />
        <div class="report-container">
          <!-- This could be a component -->
          <div class="report-body" v-if="reportData">
            <table id="table-report">
              <thead>
                <tr class="report-body__row report-body__row--header"></tr>
                <tr>
                  <th align="left">Id</th>
                  <th align="left">Employee</th>
                  <th align="left">Global Role</th>
                  <th align="left">Store</th>
                  <th align="left">Role</th>
                  <th align="left">Updated</th>
                  <th align="left">Updated By</th>
                  <th align="left">Email</th>
                  <th align="left">Cell</th>
                  <th align="left">Employment Date</th>
                  <th align="left">Srn #</th>
                  <th align="center">Safe Access</th>
                </tr>
              </thead>

              <tbody>
                <tr class="report-body__row"></tr>
                <tr v-for="(record, index) in reportData.records" :key="index">
                  <td>{{ record.id }}</td>
                  <td>{{ record.employee }}</td>
                  <td>{{ record.employeeRole }}</td>
                  <td>{{ record.store }}</td>
                  <td>{{ record.role }}</td>
                  <td>{{ record.dateUpdated }}</td>
                  <td>{{ record.employeeUpdated }}</td>
                  <td>{{ record.email }}</td>
                  <td>{{ record.cell }}</td>
                  <td>{{ dateFormmatter(record.employmentDate) }}</td>
                  <td>{{ record.srn }}</td>
                  <td align="center">{{ record.hasSaveAccess ? 'Y' : 'N' }}</td>

                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import PageHeader from "@/components/Header/Header.vue";
  import ReportHelper from "@/lib/report/index.js";
  import { mapActions, mapGetters } from "vuex";
  import ReportFilter from "@/components/ReportFilter/ReportFilter";
  import Utilities from "@/lib/Utilities";

  export default {
    data() {
      return {
        reportData: undefined,
        Utilities,
        reportType: undefined,
        selectedPeriod: undefined,
        selectedReportFor: undefined,
        selectedReportSaleType: undefined,
        filterDropdown: undefined,
      };
    },
    components: {
      PageHeader,
      ReportFilter,
    },
    created: function () {
      this.setPageTitle("Employee Listing");
    },
    mounted: function () {
      const today = new Date();
      this.selectedPeriod = {
        from: new Date(new Date().setDate(today.getDate() - 7)),
        to: today,
      };
    },
    computed: {
      ...mapGetters({
        loadingStatus: "reports/loadingStatus",
        employeeTransactions: "reports/employeeTransactions",
      }),
    },
    methods: {
      ...mapActions({
        getEmployeeTransactions: "reports/getEmployeeTransactions",
      }),

      dateFormmatter(date) {
        return Utilities.formatDate(date);
      },

      performGetReport(filter) {
        let reportType = "employeeListActive";
        this.getEmployeeTransactions({
          reportType,
          ...filter,
          positiveCallback: (data) => {
            this.reportData = data;
          },
        });
      },
      exportToCsv() {
        var table = document.getElementById("table-report");
        ReportHelper.exportToExcel(table, "employeeListActive");
      },
    },
  };
  </script>

  <style lang="scss">
  @import "./_employeeListActive.scss";